<script setup>
import {defineEmits, defineExpose, defineProps, onMounted, ref, computed} from 'vue'

const props = defineProps({
  listLength: {
    type: Number,
    required: true,
  },
  loading: {
    type: Boolean,
    required: true,
  },
  lastPage: {
    type: Boolean,
    required: true,
  },
  emptyListMessage: {
    type: String,
    required: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
  listHeight: {
    type: String,
  },
  listOverflowXHidden: {
    type: Boolean,
    default: false,
  },
  hidePreloader: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['infinite'])
const scroller = ref(null)
const endOfScroller = ref(null)

const listWrapperClass = computed(() => [
  'blur-preloader-wrapper',
  props.loading ? 'overflow-y-hidden' : '',
  props.isSmall ? 'list-wrapper__small' : 'list-wrapper',
  props.listOverflowXHidden ? 'overflow-x-hidden' : '',
  props.listHeight === 'auto'
    ? 'h-auto'
    : props.listHeight === 'content'
    ? 'list-wrapper-height-content'
    : props.listHeight === 'small'
    ? 'list-wrapper-height-small'
    : props.listHeight === 'fixed'
    ? 'list-wrapper-height-fixed'
    : 'list-wrapper-height-default',
])

const listWrapperStyle = computed(() => {
  const h = (props.listHeight || '').trim()

  if (/^\d+(\.\d+)?$/.test(h)) {
    return {height: `${h}px !important`}
  }

  return undefined
})

const scrollToTop = () => {
  scroller.value.scroll({
    top: 0,
  })
}

onMounted(() => {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          emit('infinite')
        }
      })
    },
    {root: scroller.value, threshold: 0, rootMargin: '50px'},
  )

  observer.observe(endOfScroller.value)
})

defineExpose({scrollToTop})
</script>

<template>
  <div class="list-wrapper__cover">
    <div ref="scroller" :class="listWrapperClass" :style="listWrapperStyle">
      <template v-if="loading && !hidePreloader">
        <div class="blur-preloader">
          <i class="fa fa-circle-notch fa-spin fa-2xl blur-preloader-circle"></i>
        </div>
      </template>

      <template v-if="listLength > 0">
        <div v-if="!['content', 'fixed'].includes(props.listHeight)" class="list-wrapper-table-container">
          <slot />
        </div>

        <slot v-else />
      </template>

      <template v-if="!listLength && !loading">
        <slot name="empty">
          <div class="text-center p-3 w-100">{{ emptyListMessage }}</div>
        </slot>
      </template>

      <div ref="endOfScroller" class="scroll_end">
        <span v-if="!lastPage && loading && !hidePreloader">Loading</span>
      </div>
    </div>
  </div>
</template>
